export default {
  columns: {
    name: "Naam",
    createdOn: "Aangemaakt op",
    updatedOn: "Laatste wijziging",
    status: "Status",

    // Dossier
    subject: "Onderwerp",
    type: "Type",
    from: "Van",

    // Person
    firstName: "Voornaam",
    lastName: "Achternaam",
    lastNameAffix: "Tussenvoegsel",

    // Invoice
    invoiceNumber: "Factuurnummer",
    invoiceDate: "Facturatie datum",
    invoiceDueDate: "Eind datum",

    // Company contact
    emailAddress: "E-mailadres",
    phoneNumber: "Telefoonnummer",
    function: "Functie",
  },
  order: {
    asc: "Oplopend",
    desc: "Aflopend",
  },

  paginate: {
    total: "Totaal",
    pages: "Pagina's",
  },
}
